"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enterprise_security = exports.enterprise_professional = exports.enterprise_maintenance = exports.enterprise_onboarding = exports.free_domain_1_year_bold = exports.unlimited_bandwidth_upper_flat = exports.storage_50gb_flat = exports.storage_35gb_flat = exports.storage_20gb_flat = exports.storage_10gb_flat = exports.empty_feature = exports._75_ad_vouchers_gb = exports._75_ad_vouchers = exports._300_ad_vouchers = exports.google_analytics = exports.commission_free = exports.online_payments = exports.vip_support = exports.schedule_classes_courses = exports.priority_response = exports.social_media_logo_files = exports.visitor_analytics_app_60_value = exports.visitor_analytics_60_value = exports.events_calendar_50_value = exports.professional_Logo_50_Value = exports.form_builder_app_48_value = exports.site_booster_app_60_value = exports.video_maker_8 = exports.video_maker_6 = exports.video_maker_4 = exports.video_maker_2 = exports.video_10hr = exports.video_5hr = exports.video_2hr = exports.video_1hr = exports.unlimited_bandwidth_upper = exports.domain_money_back = exports.free_business_email_1_year = exports.free_domain_1_year = exports.connect_your_domain = exports.Remove_Wix_Ads = exports.video_half_hr = exports.storage_50gb = exports.storage_35gb = exports.storage_20gb = exports.storage_10gb = exports.storage_3gb = exports.storage_500mb = exports.bandwidth_2gb = exports.bandwidth_1gb = void 0;
exports.fax_orders = exports.take_bookings = exports.send_emails_80_value = exports.storage_1tb = exports.wix_business_solutions_225_value = exports.storage_75gb = exports.wix_bookings_app_75_value = exports.send_emails_100_value = exports.storage_3tb = exports.storage_500gb = exports.rent_sell_videos = exports.offer_monthly_subscriptions = exports.commissions_0_percent = exports.staff_calendars = exports.group_bookings = exports.email_reminders = exports.professional_invoices = exports.calendar_sync = exports.email_campaigns_per_month_10 = exports.bandwidth_10gb = exports.premium_support = exports.SEO_expert_review = exports.professional_store_review = exports.emails_per_month_50000 = exports.premium_apps_2 = exports.professional_site_review = exports.storage_25gb = exports.wix_music_player = exports.channel_manager_trial = exports.advanced_pricing = exports.online_store = exports.customized_favicon = exports.live_chat = exports.wix_business_solutions = exports._3000_yandex_ad_vouchers = exports._2000_ru_google_ad_vouchers = exports.storage_100gb = exports.branded_live_chat = exports.auto_branded_live_chat = exports._50_lead_captures = exports._150_lead_captures = exports.unlimited_lead_captures = exports._1000_form_submissions = exports._5000_form_submissions = exports.unlimited_form_submissions = exports._5_email_campaigns = exports._20_email_campaigns = exports.unlimited_email_campaigns = exports.enterprise_business = exports.enterprise_support = void 0;
exports.realDealFeatures = exports.sales_analytics_and_reports = exports.pro_ecommerce_features = exports.advanced_bronze = exports.advanced_silver = exports.advanced_gold = exports.bandwidth_unlimited = exports.video_hours_100 = exports.emails_per_month_1000000 = exports.menu_builder = exports.take_reservations = exports.take_orders_online = exports.pro_menu_builder = exports.no_commissions = exports.mobile_notifications = void 0;
var types_1 = require("../../../types/types");
exports.bandwidth_1gb = {
    code: 'bandwidth_1gb',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.bandwidth_2gb = {
    code: 'bandwidth_2gb',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.storage_500mb = {
    code: 'storage_500mb',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.storage_3gb = {
    code: 'storage_3gb',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.storage_10gb = {
    code: 'storage_10gb',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.storage_20gb = {
    code: 'storage_20gb',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.storage_35gb = {
    code: 'storage_35gb',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.storage_50gb = {
    code: 'storage_50gb',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.video_half_hr = {
    code: 'video_half_hr',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.Remove_Wix_Ads = {
    code: 'Remove_Wix_Ads',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.connect_your_domain = {
    code: 'connect_your_domain',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.free_domain_1_year = {
    code: 'free_domain_1_year',
    disabledMonthly: true,
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
};
exports.free_business_email_1_year = {
    code: 'free_business_email_1_year',
    disabledMonthly: true,
    isGift: true,
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
};
exports.domain_money_back = {
    code: 'domain_money_back',
    disabledMonthly: true,
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
};
exports.unlimited_bandwidth_upper = {
    code: 'unlimited_bandwidth_upper',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.video_1hr = {
    code: 'video_1hr',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.video_2hr = {
    code: 'video_2hr',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.video_5hr = {
    code: 'video_5hr',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.video_10hr = {
    code: 'video_10hr',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.video_maker_2 = {
    code: 'video_maker_2',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.video_maker_4 = {
    code: 'video_maker_4',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.video_maker_6 = {
    code: 'video_maker_6',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.video_maker_8 = {
    code: 'video_maker_8',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.site_booster_app_60_value = {
    code: 'site_booster_app_60_value',
    disabledMonthly: true,
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
};
exports.form_builder_app_48_value = {
    code: 'form_builder_app_48_value',
    disabledMonthly: true,
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
};
exports.professional_Logo_50_Value = {
    code: 'professional_Logo_50_Value',
    disabledMonthly: true,
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
};
exports.events_calendar_50_value = {
    code: 'events_calendar_50_value',
    disabledMonthly: true,
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
};
exports.visitor_analytics_60_value = {
    code: 'visitor_analytics_60_value',
    disabledMonthly: true,
    isNew: true,
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
};
exports.visitor_analytics_app_60_value = {
    code: 'visitor_analytics_app_60_value',
    disabledMonthly: true,
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
};
exports.social_media_logo_files = {
    code: 'social_media_logo_files',
    disabledMonthly: true,
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
};
exports.priority_response = {
    code: 'priority_response',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.schedule_classes_courses = {
    code: 'schedule_classes_courses',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.vip_support = {
    code: 'vip_support',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.online_payments = {
    code: 'online_payments',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.commission_free = {
    code: 'commission_free',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.google_analytics = {
    code: 'google_analytics',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports._300_ad_vouchers = {
    code: '300_ad_vouchers',
    disabledMonthly: true,
    metadata: { adVoucherFeature: true },
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
};
exports._75_ad_vouchers = __assign(__assign({}, exports._300_ad_vouchers), { code: '75_ad_vouchers', renewalType: types_1.FeatureRenwalType.ONE_TIME });
exports._75_ad_vouchers_gb = __assign(__assign({}, exports._300_ad_vouchers), { code: '75_ad_vouchers_gb', renewalType: types_1.FeatureRenwalType.ONE_TIME });
exports.empty_feature = {
    code: 'empty_feature',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.storage_10gb_flat = {
    code: 'storage_10gb_flat',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.storage_20gb_flat = {
    code: 'storage_20gb_flat',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.storage_35gb_flat = {
    code: 'storage_35gb_flat',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.storage_50gb_flat = {
    code: 'storage_50gb_flat',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.unlimited_bandwidth_upper_flat = {
    code: 'unlimited_bandwidth_upper_flat',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.free_domain_1_year_bold = {
    code: 'free_domain_1_year_bold',
    disabledMonthly: true,
    isGift: true,
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
};
/**
 * Enterprise
 */
exports.enterprise_onboarding = {
    code: 'enterprise_onboarding',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.enterprise_maintenance = {
    code: 'enterprise_maintenance',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.enterprise_professional = {
    code: 'enterprise_professional',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.enterprise_security = {
    code: 'enterprise_security',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.enterprise_support = {
    code: 'enterprise_support',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.enterprise_business = {
    code: 'enterprise_business',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
/**
 * Business solutions
 **/
exports.unlimited_email_campaigns = {
    code: 'unlimited_email_campaigns',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports._20_email_campaigns = {
    code: '20_email_campaigns',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports._5_email_campaigns = {
    code: '5_email_campaigns',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.unlimited_form_submissions = {
    code: 'unlimited_form_submissions',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports._5000_form_submissions = {
    code: '5000_form_submissions',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports._1000_form_submissions = {
    code: '1000_form_submissions',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.unlimited_lead_captures = {
    code: 'unlimited_lead_captures',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports._150_lead_captures = {
    code: '150_lead_captures',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports._50_lead_captures = {
    code: '50_lead_captures',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.auto_branded_live_chat = {
    code: 'auto_branded_live_chat',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.branded_live_chat = {
    code: 'branded_live_chat',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.storage_100gb = {
    code: 'storage_100gb',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports._2000_ru_google_ad_vouchers = {
    code: '2000_ru_google_ad_vouchers',
    disabledMonthly: true,
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
};
exports._3000_yandex_ad_vouchers = {
    code: '3000_yandex_ad_vouchers',
    disabledMonthly: true,
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
};
exports.wix_business_solutions = {
    code: 'wix_business_solutions',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.live_chat = {
    code: 'live_chat',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
// old product features
exports.customized_favicon = {
    code: 'customized_favicon',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.online_store = {
    code: 'online_store',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.advanced_pricing = {
    code: 'advanced_pricing',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.channel_manager_trial = {
    code: 'channel_manager_trial',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.wix_music_player = {
    code: 'wix_music_player',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.storage_25gb = {
    code: 'storage_25gb',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.professional_site_review = {
    code: 'professional_site_review',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.premium_apps_2 = {
    code: 'premium_apps_2',
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
};
exports.emails_per_month_50000 = {
    code: 'emails_per_month_50,000',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.professional_store_review = {
    code: 'professional_store_review',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.SEO_expert_review = {
    code: 'SEO_expert_review',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.premium_support = {
    code: 'premium_support',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.bandwidth_10gb = {
    code: 'bandwidth_10gb',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.email_campaigns_per_month_10 = {
    code: 'email_campaigns_per_month_10',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.calendar_sync = {
    code: 'calendar_sync',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.professional_invoices = {
    code: 'professional_invoices',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.email_reminders = {
    code: 'email_reminders',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.group_bookings = {
    code: 'group_bookings',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.staff_calendars = {
    code: 'staff_calendars',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.commissions_0_percent = {
    code: 'commissions_0_percent',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.offer_monthly_subscriptions = {
    code: 'offer_monthly_subscriptions',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.rent_sell_videos = {
    code: 'rent_sell_videos',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.storage_500gb = {
    code: 'storage_500gb',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.storage_3tb = {
    code: 'storage_3tb',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.send_emails_100_value = {
    code: 'send_emails_100_value',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.wix_bookings_app_75_value = {
    code: 'wix_bookings_app_75_value',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.storage_75gb = {
    code: 'storage_75gb',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.wix_business_solutions_225_value = {
    code: 'wix_business_solutions_225_value',
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
};
exports.storage_1tb = {
    code: 'storage_1tb',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.send_emails_80_value = {
    code: 'send_emails_80_value',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.take_bookings = {
    code: 'take_bookings',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.fax_orders = {
    code: 'fax_orders',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.mobile_notifications = {
    code: 'mobile_notifications',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.no_commissions = {
    code: 'no_commissions',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.pro_menu_builder = {
    code: 'pro_menu_builder',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.take_orders_online = {
    code: 'take_orders_online',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.take_reservations = {
    code: 'take_reservations',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.menu_builder = {
    code: 'menu_builder',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.emails_per_month_1000000 = {
    code: 'emails_per_month_1,000,000',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.video_hours_100 = {
    code: 'video_hours_100',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.bandwidth_unlimited = {
    code: 'bandwidth_unlimited',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.advanced_gold = {
    code: 'advanced_gold',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.advanced_silver = {
    code: 'advanced_silver',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.advanced_bronze = {
    code: 'advanced_bronze',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.pro_ecommerce_features = {
    code: 'pro_ecommerce_features',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.sales_analytics_and_reports = {
    code: 'sales_analytics_and_reports',
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.realDealFeatures = {
    bandwidth_1gb: exports.bandwidth_1gb,
    bandwidth_2gb: exports.bandwidth_2gb,
    storage_500mb: exports.storage_500mb,
    storage_3gb: exports.storage_3gb,
    storage_10gb: exports.storage_10gb,
    storage_20gb: exports.storage_20gb,
    storage_35gb: exports.storage_35gb,
    storage_50gb: exports.storage_50gb,
    video_half_hr: exports.video_half_hr,
    Remove_Wix_Ads: exports.Remove_Wix_Ads,
    connect_your_domain: exports.connect_your_domain,
    free_domain_1_year: exports.free_domain_1_year,
    free_business_email_1_year: exports.free_business_email_1_year,
    domain_money_back: exports.domain_money_back,
    unlimited_bandwidth_upper: exports.unlimited_bandwidth_upper,
    video_1hr: exports.video_1hr,
    video_2hr: exports.video_2hr,
    video_5hr: exports.video_5hr,
    video_10hr: exports.video_10hr,
    video_maker_2: exports.video_maker_2,
    video_maker_4: exports.video_maker_4,
    video_maker_6: exports.video_maker_6,
    video_maker_8: exports.video_maker_8,
    site_booster_app_60_value: exports.site_booster_app_60_value,
    form_builder_app_48_value: exports.form_builder_app_48_value,
    professional_Logo_50_Value: exports.professional_Logo_50_Value,
    events_calendar_50_value: exports.events_calendar_50_value,
    visitor_analytics_60_value: exports.visitor_analytics_60_value,
    visitor_analytics_app_60_value: exports.visitor_analytics_app_60_value,
    social_media_logo_files: exports.social_media_logo_files,
    priority_response: exports.priority_response,
    schedule_classes_courses: exports.schedule_classes_courses,
    vip_support: exports.vip_support,
    online_payments: exports.online_payments,
    commission_free: exports.commission_free,
    google_analytics: exports.google_analytics,
    _300_ad_vouchers: exports._300_ad_vouchers,
    _75_ad_vouchers: exports._75_ad_vouchers,
    _75_ad_vouchers_gb: exports._75_ad_vouchers_gb,
    empty_feature: exports.empty_feature,
    storage_10gb_flat: exports.storage_10gb_flat,
    storage_20gb_flat: exports.storage_20gb_flat,
    storage_35gb_flat: exports.storage_35gb_flat,
    storage_50gb_flat: exports.storage_50gb_flat,
    unlimited_bandwidth_upper_flat: exports.unlimited_bandwidth_upper_flat,
    free_domain_1_year_bold: exports.free_domain_1_year_bold,
    enterprise_onboarding: exports.enterprise_onboarding,
    enterprise_maintenance: exports.enterprise_maintenance,
    enterprise_professional: exports.enterprise_professional,
    enterprise_security: exports.enterprise_security,
    enterprise_support: exports.enterprise_support,
    enterprise_business: exports.enterprise_business,
    unlimited_email_campaigns: exports.unlimited_email_campaigns,
    _20_email_campaigns: exports._20_email_campaigns,
    _5_email_campaigns: exports._5_email_campaigns,
    unlimited_form_submissions: exports.unlimited_form_submissions,
    _5000_form_submissions: exports._5000_form_submissions,
    _1000_form_submissions: exports._1000_form_submissions,
    unlimited_lead_captures: exports.unlimited_lead_captures,
    _150_lead_captures: exports._150_lead_captures,
    _50_lead_captures: exports._50_lead_captures,
    auto_branded_live_chat: exports.auto_branded_live_chat,
    branded_live_chat: exports.branded_live_chat,
    storage_100gb: exports.storage_100gb,
    _2000_ru_google_ad_vouchers: exports._2000_ru_google_ad_vouchers,
    _3000_yandex_ad_vouchers: exports._3000_yandex_ad_vouchers,
    wix_business_solutions: exports.wix_business_solutions,
    live_chat: exports.live_chat,
    customized_favicon: exports.customized_favicon,
    online_store: exports.online_store,
    advanced_pricing: exports.advanced_pricing,
    channel_manager_trial: exports.channel_manager_trial,
    wix_music_player: exports.wix_music_player,
    storage_25gb: exports.storage_25gb,
    professional_site_review: exports.professional_site_review,
    premium_apps_2: exports.premium_apps_2,
    emails_per_month_50000: exports.emails_per_month_50000,
    professional_store_review: exports.professional_store_review,
    SEO_expert_review: exports.SEO_expert_review,
    premium_support: exports.premium_support,
    bandwidth_10gb: exports.bandwidth_10gb,
    email_campaigns_per_month_10: exports.email_campaigns_per_month_10,
    calendar_sync: exports.calendar_sync,
    professional_invoices: exports.professional_invoices,
    email_reminders: exports.email_reminders,
    group_bookings: exports.group_bookings,
    staff_calendars: exports.staff_calendars,
    commissions_0_percent: exports.commissions_0_percent,
    offer_monthly_subscriptions: exports.offer_monthly_subscriptions,
    rent_sell_videos: exports.rent_sell_videos,
    storage_500gb: exports.storage_500gb,
    storage_3tb: exports.storage_3tb,
    send_emails_100_value: exports.send_emails_100_value,
    wix_bookings_app_75_value: exports.wix_bookings_app_75_value,
    storage_75gb: exports.storage_75gb,
    wix_business_solutions_225_value: exports.wix_business_solutions_225_value,
    storage_1tb: exports.storage_1tb,
    send_emails_80_value: exports.send_emails_80_value,
    take_bookings: exports.take_bookings,
    fax_orders: exports.fax_orders,
    mobile_notifications: exports.mobile_notifications,
    no_commissions: exports.no_commissions,
    pro_menu_builder: exports.pro_menu_builder,
    take_orders_online: exports.take_orders_online,
    take_reservations: exports.take_reservations,
    menu_builder: exports.menu_builder,
    emails_per_month_1000000: exports.emails_per_month_1000000,
    video_hours_100: exports.video_hours_100,
    bandwidth_unlimited: exports.bandwidth_unlimited,
    advanced_gold: exports.advanced_gold,
    advanced_silver: exports.advanced_silver,
    advanced_bronze: exports.advanced_bronze,
    pro_ecommerce_features: exports.pro_ecommerce_features,
    sales_analytics_and_reports: exports.sales_analytics_and_reports,
};
//# sourceMappingURL=features.js.map